module.exports = __webpack_public_path__ + "media/luxury-2026/black-tub-a6319825.jpg";